import React from "react";

import {

    Drawer,
    Toolbar,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Typography,
    Box

} from "@mui/material";

import { NavLink } from "react-router-dom";

import menu from "./menu";

const drawerWidth = 250;

export default function Sidebar({

    mobileOpen,
    handleDrawerToggle

}) {

    const drawer = (

        <div>

            <Toolbar>

                <Box>

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        color="primary"
                    >
                        U2USYSTEMS
                    </Typography>

                    <Typography
                        variant="caption"
                    >
                        Knowledge Hub
                    </Typography>

                </Box>

            </Toolbar>

            <Divider />

            <List>

                {

                    menu.map((item) => {

                        const Icon = item.icon;

                        return (

                            <ListItemButton

                                key={item.id}

                                component={NavLink}

                                to={item.path}

                                sx={{

                                    "&.active": {

                                        backgroundColor: "#E3F2FD",

                                        borderRight:
                                            "4px solid #1976d2"

                                    },

                                    "&:hover": {

                                        backgroundColor:
                                            "#F5F5F5"

                                    }

                                }}

                            >

                                <ListItemIcon>

                                    <Icon />

                                </ListItemIcon>

                                <ListItemText

                                    primary={item.title}

                                />

                            </ListItemButton>

                        );

                    })

                }

            </List>

        </div>

    );

    return (

        <Box
            component="nav"
            sx={{
                width: {
                    md: drawerWidth
                },
                flexShrink: {
                    md: 0
                }
            }}
        >

            {/* Mobile */}

            <Drawer

                variant="temporary"

                open={mobileOpen}

                onClose={handleDrawerToggle}

                ModalProps={{
                    keepMounted: true
                }}

                sx={{

                    display: {

                        xs: "block",

                        md: "none"

                    },

                    "& .MuiDrawer-paper": {

                        width: drawerWidth

                    }

                }}

            >

                {drawer}

            </Drawer>

            {/* Desktop */}

            <Drawer

                variant="permanent"

                sx={{

                    display: {

                        xs: "none",

                        md: "block"

                    },

                    "& .MuiDrawer-paper": {

                        width: drawerWidth,

                        boxSizing: "border-box"

                    }

                }}

                open

            >

                {drawer}

            </Drawer>

        </Box>

    );

}